// Single source of truth for FAQ content.
// No React imports — safe to import from both client and server.
// Used by: src/pages/Help.jsx, src/components/landing/FAQ.jsx,
//           server/middleware/seo.js (via renderHelpSchema)

export const FAQS = [
    {
        id: 'cost',
        question: 'How much does PostPaid cost?',
        answer: 'PostPaid is free to join for both brands and creators. A flat 20% platform fee is included in your campaign budget — 80% goes to creators, 20% is the platform fee.',
        audiences: ['brand'],
    },
    {
        id: 'who-can-join',
        question: 'Who can join PostPaid as a creator?',
        answer: 'Any creator with an active Instagram or TikTok account can join. There is no minimum follower count — PostPaid pays per verified interaction, so smaller, highly engaged audiences are welcome.',
        audiences: ['creator'],
    },
    {
        id: 'platforms',
        question: 'Which social networks does PostPaid support?',
        answer: 'PostPaid supports Instagram and TikTok.',
        audiences: ['creator', 'brand'],
    },
    {
        id: 'verification',
        question: 'How are interactions verified on PostPaid?',
        answer: 'PostPaid connects directly to each creator\'s social account to read verified engagement data (likes, comments, shares, views). Nothing is self-reported.',
        audiences: ['creator', 'brand'],
    },
    {
        id: 'payouts',
        question: 'When and how do creators get paid?',
        answer: 'Earnings accrue in near-real-time as interactions are verified. Creators can withdraw on demand in EUR or USD. Cryptocurrency payouts are on the roadmap.',
        audiences: ['creator'],
    },
    {
        id: 'launch-time',
        question: 'How long does it take to launch a campaign?',
        answer: 'Campaigns can be live within minutes of funding. Creators typically begin applying within the first 24 hours.',
        audiences: ['brand'],
    },
    {
        id: 'advance',
        question: 'Does PostPaid pay creators in advance?',
        answer: 'No. Creators are paid automatically for verified interactions after they post, from an escrowed campaign budget.',
        audiences: ['brand', 'creator'],
    },
    {
        id: 'escrow',
        question: 'What happens to a brand\'s budget if creators don\'t deliver?',
        answer: 'Campaign budgets sit in escrow and are only released for interactions PostPaid can verify on the creator\'s social account. Unspent budget at the end of a campaign is returned to the brand.',
        audiences: ['brand'],
    },
    {
        id: 'pricing-control',
        question: 'Who decides the price per interaction?',
        answer: 'Brands set their own price for each interaction type (like, comment, share, view) when creating a campaign. Creators see those prices up front and choose whether to apply.',
        audiences: ['brand', 'creator'],
    },
    {
        id: 'taxes',
        question: 'Does PostPaid handle taxes?',
        answer: 'Creators are responsible for declaring their earnings to their local tax authority. PostPaid provides a downloadable earnings statement from the dashboard.',
        audiences: ['creator'],
    },
    {
        id: 'countries',
        question: 'Where is PostPaid available?',
        answer: 'PostPaid is available globally. Payouts currently support EUR and USD bank withdrawals; check the dashboard for the latest list of supported payout regions.',
        audiences: ['creator', 'brand'],
    },
    {
        id: 'account-deletion',
        question: 'How do I delete my account?',
        answer: 'You can delete your account at any time from Settings → Account. Withdraw any remaining balance first. Account deletion removes your profile and disconnects your social accounts; campaign records are retained as required by law.',
        audiences: ['creator', 'brand'],
    },
    {
        id: 'disputes',
        question: 'What if there\'s a dispute on a campaign?',
        answer: 'Contact support through the Contact page. Because interactions are verified directly from the social platform, most disagreements are resolved by reviewing the engagement data on file.',
        audiences: ['creator', 'brand'],
    },
];

export const faqsFor = (audience) => FAQS.filter((f) => f.audiences.includes(audience));
